























import Vue from "vue";
import { RootState } from "@/store";
import { mapState } from "vuex";

// Vue components
import VFaIcon from "@/components/VFaIcon.vue";
import DashboardLayout from "./DashboardLayout.vue";
import WidgetConfiguratorCard from "./configurator/WidgetConfiguratorCard.vue";

// Model
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { FetchDashboardCommand } from "@/model/communication/dashboard/dashboard/FetchDashboardCommand";
import { DashboardWidget } from "@/model/data/dashboard/DashboardWidget";
import { CreateDashboardWidgetCommand } from "@/model/communication/dashboard/widget/CreateDashboardWidgetCommand";
import { DeleteDashboardWidgetCommand } from "@/model/communication/dashboard/widget/DeleteDashboardWidgetCommand";

export default Vue.extend({
    components: {
        DashboardLayout,
        WidgetConfiguratorCard,
        VFaIcon,
    },
    data() {
        return {
            dashboard: null,
            showWidgetConfiguratorDialog: false,
            tempWidget: null,
            isNewWidget: true,
            dashboardNotAvailable: false,
        };
    },
    computed: {
        ...mapState({
            tvMode: (s: RootState) => s.application.tvMode,
        }),
        dashboardId() {
            return this.$route.params.id;
        },
        currentBreakpoint() {
            return this.$vuetify.breakpoint.name;
        },
    },
    watch: {
        currentBreakpoint: {
            handler() {
                this.fetchDashboard();
            },
            deep: true,
        },
        $route: "fetchDashboard",
    },
    methods: {
        async fetchDashboard() {
            const res = await new FetchDashboardCommand(this.dashboardId, this.$vuetify.breakpoint.name).execute();
            if (res.responseStatus == ApiResponseStatusEnum.Success) {
                if (res.dashboard == null) this.dashboardNotAvailable = true;
                this.dashboard = res.dashboard;
            } else {
                this.dashboardNotAvailable = true;
                console.error("cannot fetch dashboard by id:", this.dashboardId);
            }
        },

        async duplicateWidget(widgetToDuplicate: DashboardWidget) {
            try {
                let tempWidget = widgetToDuplicate.clone();
                tempWidget.title = tempWidget.title + " (" + this.$t("common.copy") + ")";

                let res = await new CreateDashboardWidgetCommand(tempWidget).execute();

                if (res.responseStatus != ApiResponseStatusEnum.Success) {
                    console.error("Error trying duplicate widget with id: ", widgetToDuplicate.id);
                    this.errorMessage = this.$t("dashboard.cannotSaveWidget");
                }
                this.fetchDashboard();
            } catch (error) {
                this.errorMessage = this.$t("dashboard.cannotSaveWidget");
                console.error("Error trying duplicate widget with id: ", widgetToDuplicate.id, " error: ", error);
                this.fetchDashboard();
            }
        },

        onEdit(widgetToEdit: DashboardWidget) {
            console.log("onEdit widget id: ", widgetToEdit.id);
            this.tempWidget = widgetToEdit.clone();
            this.isNewWidget = false;
            this.showWidgetConfiguratorDialog = true;
        },

        addNewWidget() {
            console.log("Add new widget called");
            this.tempWidget = new DashboardWidget();
            this.tempWidget.dashboardId = this.dashboardId;

            this.tempWidget.positionAndSizeList = [];
            let obj = { breakpoint: "lg", x: 0, y: 0, width: 2, height: 2 };
            this.tempWidget.positionAndSizeList.push(obj);

            this.isNewWidget = true;
            this.showWidgetConfiguratorDialog = true;
        },
        async deleteWidget(widget) {
            try {
                let res = await new DeleteDashboardWidgetCommand(widget.id).execute();
                if (res.responseStatus != ApiResponseStatusEnum.Success) {
                    console.error("Error trying delete widget with id: ", widget.id);
                }
            } catch (error) {
                console.error("Error trying delete widget with id: ", widget.id, " error: ", error);
            }
            this.fetchDashboard();
        },
    },
    mounted() {
        this.fetchDashboard();
    },
});
